import { cn } from "@/lib/utils";
import React from "react"

const Container = ({ 
  children,
  className
}: { 
  children: React.ReactNode;
  className?: any
}) => {
  return (
    <div className={cn("px-4 py-2 pb-4", className)}>
      {children}
    </div>
  )
}

export default Container;